<template>
	<!-- eslint-disable vue/no-v-html -->
	<div 
		:id="id" 
		v-show="isCmeInfoModalVisible" 
		class="cmeinfo-modal modal fixed inset-0 text-sm"
	>
		<section class="absolute inset-0 bg-bg-002 opacity-30"></section>
		<div class="modal-close flex flex-row fixed top-12 left-1/2 justify-end w-11/12 md:w-10/12 px-5 transform -translate-x-1/2 pointer-events-none">
			<UiButton
				class="pointer-events-auto"
				type="icon"
				name="close"
				:on-click="hideCmeInfoModal"
			/>
		</div>
		<section class="hide-scrollbar w-full h-full max-h-full relative overflow-auto" @click="hideCmeInfoModal">
			<article class="modal-content w-11/12 md:w-10/12 m-auto bg-bg-001 my-8 p-5 shadow-default pointer-events-auto" @click.stop="">
				<header class="mb-5">
					<div>
						<h1 class="text-2xl">{{ label }} Info & Disclosures</h1>
					</div>
				</header>
				<section class="panels grid grid-cols-1 gird-rows-auto gap-5">
					<section>
						<div class="logos flex flex-col md:flex-row items-start mb-8">
							<img 
								src="https://secureapi.atpoc.com/assets/production/breakingmed/logos/PIK.gif"
								alt="Projects In Knowledge" 
							>
							<img 
								src="https://secureapi.atpoc.com/assets/production/breakingmed/logos/TIK.gif"
								alt="Peer Reviewed" 
							>
						</div>
					</section>
					<section v-if="content.funder_line">
						<h4>Acknowledgement</h4>
						<p v-html="content.funder_line"></p>
					</section>
					<section v-if="content.authorbyline">
						<h4>Medical Writer</h4>
						<p v-html="content.authorbyline"></p>
					</section>
					<section v-if="content.reviewerbyline">
						<h4>Reviewer</h4>
						<p v-html="content.reviewerbyline"></p>
					</section>
					<section v-if="content.releasedate">
						<h4>{{ label }}</h4>
						<table class="table-auto w-full border border-gray-004 text-center">
							<tr class="border-b border-gray-004">
								<th class="border-r border-gray-004"></th>
								<th class="border-r border-gray-004">Physicians</th>
								<th>Nurses</th>
							</tr>
							<tr class="border-b border-gray-004">
								<td class="border-r border-gray-004"><strong>Release Date</strong></td>
								<td class="border-r border-gray-004">{{ content.releasedate.split(' ')[0] }}</td>
								<td>{{ content.releasedate.split(' ')[0] }}</td>
							</tr>
							<tr v-if="content.termdate">
								<td class="border-r border-gray-004"><strong>Termination Date</strong></td>
								<td class="border-r border-gray-004">{{ content.termdate }}</td>
								<td>{{ content.termdate }}</td>
							</tr>
						</table>
					</section>
					<section v-if="hasEstimate">
						<h4>Estimated time for completion of this activity</h4>
						<p v-if="content.cme_credit">CME: {{ content.cme_credit }}</p>
						<p v-if="content.ce_credit">CNE: {{ content.ce_credit }}</p>
						<p v-if="hasMoc">{{ content.moc_credit_information }}</p>
					</section>
					<section v-if="content.cmedisclosures">
						<h4>CME/CE Instructions</h4>
						<p v-html="content.cmedisclosures"></p>
					</section>
					<section v-if="content.contact_information">
						<h4>Contact Information</h4>
						<p v-html="content.contact_information"></p>
					</section>
					<section v-if="content.target_audience">
						<h4>Target Audience</h4>
						<p v-html="content.target_audience"></p>
					</section>
					<section v-if="content.activity_goal">
						<h4>Activity Goal</h4>
						<p v-html="content.activity_goal"></p>
					</section>
					<section v-if="content.learning_objectives">
						<h4>Learning Objectives</h4>
						<p v-html="content.learning_objectives"></p>
					</section>
					<section v-if="content.cme_statement">
						<p v-html="content.cme_statement"></p>
					</section>
					<section v-if="content.nursingcestatement">
						<p v-html="content.nursingcestatement"></p>
					</section>
					<section v-if="content.responsibility_contract">
						<h4>Contract for Mutual Responsibility in CME/CE</h4>
						<p v-html="content.responsibility_contract"></p>
					</section>
				</section>
				<footer class="mt-5">
					<p v-if="content.trademark" v-html="content.trademark"></p>
					<p v-if="content.jobnum">{{ content.jobnum }}</p>
				</footer>
			</article>
		</section>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiButton from '@/components/ui/Button'

/* eslint-disable no-console */
export default {
	name: 'CmeInfoModal',
	components: {
		UiButton,
	},
	mixins: [
		globalMixins
	],
	props: {
		id: {
			type: String,
			default: 'cmeInfoModal'
		},
		json: {
			type: String,
			default: null
		},
		label: {
			type: String,
			default: null
		}
	},
	computed: {
		content() {
			return JSON.parse(this.json)
		},
		hasEstimate() {
			return this.content.cme_credit || this.content.cme_credit || this.hasMoc
		},
		hasMoc() {
			return this.content.is_moc && this.content.moc_credit_information
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.cmeinfo-modal { z-index: 998; }
.modal-close { z-index: 997; }

.modal-close,
.modal-content { max-width: 800px !important; }

.panels > section { 
	padding-top: 1.25rem !important; 
	padding-bottom: 1.25rem !important; 
	border-bottom: 1px solid var(--color-gray-004);
}

.panels > section > h4 { font-weight: 700 !important; }

.panels > section table th,
.panels > section table td { padding: 1.25rem; }

.logos > img { height: 75px !important; }
</style>